import { render, staticRenderFns } from "./CouponOverview.vue?vue&type=template&id=7846bcd4&scoped=true&"
import script from "./CouponOverview.vue?vue&type=script&lang=js&"
export * from "./CouponOverview.vue?vue&type=script&lang=js&"
import style0 from "./CouponOverview.vue?vue&type=style&index=0&id=7846bcd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7846bcd4",
  null
  
)

export default component.exports